export default "__VITE_ASSET__5770c13b__"